import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_obiter-clat/artifacts/lfcvtw4r_PHOTO-2026-01-28-20-29-49.jpg";

const navLinks = [
  { label: "Why Us", href: "#problem" },
  { label: "Approach", href: "#approach" },
  { label: "Mentor", href: "#mentor" },
  { label: "Batch Details", href: "#batch" },
  { label: "FAQs", href: "#faqs" },
];

const GOOGLE_FORM_URL = "https://docs.google.com/forms/d/e/1FAIpQLSc1jDfsBoci1VGf3xZniRsxsgCGi8PBPO5lXzw6hm8XIAdBuA/viewform?usp=send_form";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavClick = (e, href) => {
    e.preventDefault();
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/95 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <a
            href="#hero"
            data-testid="navbar-logo"
            onClick={(e) => handleNavClick(e, "#hero")}
            className="flex items-center gap-3"
          >
            <img
              src={LOGO_URL}
              alt="The Obiter"
              className="h-10 w-10 rounded-full object-cover"
            />
            <span className="font-heading font-semibold text-lg text-zinc-900 hidden sm:block">
              The Obiter
            </span>
          </a>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                data-testid={`nav-link-${link.label.toLowerCase().replace(/\s/g, "-")}`}
                onClick={(e) => handleNavClick(e, link.href)}
                className="nav-link text-sm font-body font-medium text-zinc-600 hover:text-orange-600 transition-colors"
              >
                {link.label}
              </a>
            ))}
            <a
              href={GOOGLE_FORM_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="nav-apply-btn"
              className="btn-lift bg-orange-600 hover:bg-orange-700 text-white text-sm font-medium px-6 py-2.5 rounded-full transition-all"
            >
              Apply Now
            </a>
          </div>

          {/* Mobile Toggle */}
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden p-2 text-zinc-700"
          >
            {mobileOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div
          data-testid="mobile-menu"
          className="md:hidden bg-white border-t border-zinc-100 shadow-lg"
        >
          <div className="px-6 py-4 space-y-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                data-testid={`mobile-nav-${link.label.toLowerCase().replace(/\s/g, "-")}`}
                onClick={(e) => handleNavClick(e, link.href)}
                className="block py-3 text-sm font-body font-medium text-zinc-700 hover:text-orange-600 transition-colors border-b border-zinc-50 last:border-0"
              >
                {link.label}
              </a>
            ))}
            <a
              href={GOOGLE_FORM_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="mobile-apply-btn"
              className="block mt-3 text-center bg-orange-600 text-white text-sm font-medium px-6 py-3 rounded-full"
            >
              Apply Now
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}
